import { FormFooter, FormFooterCancel, FormFooterSubmit } from 'components';
import { useFormPrompt } from 'hooks';
import { useFormContext } from 'libs/form/useFormContext';
import { useDirectoryContext } from 'modules/directory/common/providers/DirectoryProvider';

interface SubmitableFormFooterProps {
  submitLoading: boolean;
}

export const EditableFormFooter = ({
  submitLoading,
}: SubmitableFormFooterProps) => {
  const { readOnly, dirty, setReadOnly } = useFormContext();
  const editable = !readOnly;

  const { onDisableEdit } = useDirectoryContext();
  const { confirmIsChanged } = useFormPrompt();

  const disableEditable = () => {
    confirmIsChanged(() => onDisableEdit(() => setReadOnly(true)));
  };

  return (
    <FormFooter visible={editable}>
      <FormFooterCancel onClick={disableEditable} />
      <FormFooterSubmit disabled={!dirty} loading={submitLoading} />
    </FormFooter>
  );
};
